import { Component, Input, ViewChild, ElementRef, OnInit } from '@angular/core';
import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { PhoneNumberValidator } from './phone-number-validator.service';
import { SessionService } from '../../core/session.service';

@Component({
    selector: 'rosie-phone',
    styleUrls: ['./phone-input.component.scss'],
    template: `
    <ng-container *ngIf="control">
      <div class="rosie-phone-input-group">
        <input [type]="'tel'" [formControl]="control" #phoneInput
             [placeholder]="placeholderTranslationKey | translate"
             [class]="'rosie-form-control form-control rosie-phone-form-control'" [maxlength]="15"
            [attr.inputmode]="'tel'" [dataHook]="field" scrollIntoView phoneMask 
             [mask]="mask" [phoneControl]="control" 
             (focus)="handleOnFocus($event)" (blur)="handleOnBlur($event)">
            <rosie-validation-error [show]="control?.invalid && control?.touched && control?.value && !control?.errors?.duplicate"
                      [translationKey]="'COMMON.VALIDATION.INVALID_PHONE'"></rosie-validation-error>
            <rosie-validation-error [show]="control?.errors?.duplicate && control?.touched"
          [translationKey]="'COMMON.VALIDATION.DUPLICATE'" [translationAttributes]="{value: 'phone number'}">
        </rosie-validation-error>
             <label *ngIf="labelTranslationKey"  [class]="'rosie-phone-form-label rosie-form-control-label'">
                 {{labelTranslationKey | translate}}
             </label>
      </div>
    </ng-container>
  `,
    standalone: false
})
export class PhoneInputComponent {
  errorMessages: string[] = [];
  isPhoneInputFocused = false;

  @Input() control: AbstractControl;
  @Input() labelTranslationKey: AbstractControl;
  @Input() placeholderTranslationKey: AbstractControl;
  @ViewChild('phoneInput') phoneInput: ElementRef;

  constructor(private phoneValidator: PhoneNumberValidator, private session: SessionService) { }

  ngOnInit(): void {
    if (this.control) {
      this.control.setAsyncValidators(this.phoneValidator.validate.bind(this.phoneValidator));
    }
  }

  handleOnFocus(event: Event): void {
    this.control.markAsUntouched();
    this.scrollIntoViewIfNeeded();
  }

  handleOnBlur(event: Event): void {
  }

  private scrollIntoViewIfNeeded(): void {
    if (this.isMobileDevice()) {
      setTimeout(() => {
        if (this.phoneInput?.nativeElement) {
          this.phoneInput.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          });
        }
      }, 300);
    }
  }

  private isMobileDevice(): boolean {
    return this.session.isMobileVersion;
  }

  get mask(): string {
    return '(000) 000-0000';
  }
}
